import type { ReactNode } from "react";
import { userHasGlobalScope } from "../auth/scopes";
import { useAuth } from "../contexts/AuthContext";

export default function DevOnly({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!userHasGlobalScope(user, "dev:read")) return null;
  return <>{children}</>;
}
